const validate = values => {
  const errors = {}
  if(!values.firstName){
    errors.firstName = 'Required'
  }
  if(!values.lastName){
    errors.lasttName = 'Required'
  }
  if(!values.email){
    errors.email = 'Required'
  }
  if(!values.phone){
    errors.phone = 'Required'
  }
  if(!values.companyInfo){
    errors.companyInfo = 'Required'
  }
  if(!values.companyLocation){
    errors.companyLocation = 'Required'
  }
  if(!values.companyPostion){
    errors.companyPostion = 'Required'
  }
  if(!values.aboutProject){
    errors.aboutProject = 'Required'
  }
  if(!values.projectGoals){
    errors.projectGoals = 'Required'
  }
}
export default validate


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/GettingStarted/helpers/validate.js